import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum VisibilityStatus {
  PRIVATE = 'PRIVATE',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED_PUBLIC = 'APPROVED_PUBLIC',
}

export interface StudentDecision {
  user: string
  decision_id: string
  student_id: number
  decision: string
  adjudication?: string | null
  user_name?: string
  user_profile_picture?: string
  late_submission?: boolean
  is_public?: boolean
  visibility_status?: VisibilityStatus
  round_number?: number
  phase_id?: number
  formatted_decision?: string
  decision_justification?: string | null
  selected_research_option_index?: number | null
}

export interface StudentDecisionState {
  isConnected: boolean
  decisions: StudentDecision[]
}

const initialState: StudentDecisionState = {
  isConnected: false,
  decisions: [],
}

const studentDecisionSlice = createSlice({
  name: 'studentDecision',
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload
    },
    setDecisions: (state, action: PayloadAction<StudentDecision[]>) => {
      state.decisions = action.payload
    },
    updateStudentDecisions: (state, action: PayloadAction<StudentDecision>) => {
      state.decisions = [...state.decisions, action.payload]
    },
    updateAdjudication: (state, action: PayloadAction<StudentDecision>) => {
      const decision = state.decisions.find(
        (d) => d.decision_id === action.payload.decision_id
      )
      if (decision) {
        decision.adjudication = action.payload.adjudication
        decision.visibility_status = action.payload.visibility_status
        decision.formatted_decision = action.payload.formatted_decision
      }
    },
  },
})

export const {
  setConnectionStatus,
  updateStudentDecisions,
  setDecisions,
  updateAdjudication,
} = studentDecisionSlice.actions

export default studentDecisionSlice.reducer
